
export const fileTypes = {
  CSV: "csv",
  TEXT: "text",
  JSON: "json",
  EXCEL: "excel",
  TXT: "txt",
};
export const triggerTypes = {
  "Schedule Trigger": "ScheduleTrigger",
  "Blob Events Trigger": "BlobEventsTrigger",
};
